import { render, staticRenderFns } from "./Distributor_roles.vue?vue&type=template&id=6413df4a&scoped=true&lang=pug&"
import script from "./Distributor_roles.vue?vue&type=script&lang=coffee&"
export * from "./Distributor_roles.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6413df4a",
  null
  
)

export default component.exports